import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ValidationInput } from '../inputs';
import { CreateChancel } from '../buttons';
import { TextToolTip } from '../toolTip';
import { NewDragAndDrop, renderFileTypeSvg } from '../documentsNew';
import { httpRequestsOnSuccessActions, resourceActions, } from 'store';
import { UploadServices } from '../../store/authServices/uplodService';
import { ErrorText, FindLoad, FindSuccessItem, Images, useGlobalStyles, useGlobalTextStyles, useModal } from 'utils';

export const UploadModal = ({ onResource, editActionType, currentId, defaultValue }) => {
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalTextStyles();

  const actionType =
    defaultValue ?
      onResource === 'resource' ? 'EDIT_RESOURCE_DOCUMENT' :
        ''
      :
      onResource === 'resource' ? 'UPLOAD_RESOURCE_DOCUMENT' :
        '';

  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadLoader, setUploadLoader] = useState(false);
  const dispatch = useDispatch();
  const addLoader = FindLoad(actionType);
  const editLoader = FindLoad(editActionType);
  const success = FindSuccessItem(actionType);
  const successEdit = FindSuccessItem(editActionType);
  const { close } = useModal();


  useEffect(() => {
    if (defaultValue) {
      setUploadedFiles(defaultValue);
      setInputs({ name: defaultValue?.name, description: defaultValue?.description });
    }
  }, [defaultValue]);

  const handleUpload = (file) => {
    error === 'currentFile' && setError('');

    if (file && inputs.name) {
      const pos = file.type.slice(file.type.search('/'));
      const fileType = pos.substring(1);
      const info = {
        file: file,
        name: inputs?.name,
        description: inputs?.description,
        format: fileType,

      };
      setUploadedFiles([info, ...uploadedFiles]);
      setInputs({});
    }
  };


  const handleSubmit = async () => {
    if (uploadedFiles?.length) {
      setUploadLoader(true);

      const formData = new FormData();
      uploadedFiles?.map((e) => {
        formData.append('files', e?.file);
      });

      const res = await UploadServices.UploadManyImage(formData);

      const mixedList = res?.data?.map((file, index) => ({
        file: {
          ...file,
          format: uploadedFiles[index]?.format,
        },
        name: uploadedFiles[index]?.name,
        description: uploadedFiles[index]?.description || '',
      }));

      const sendList = {
        documents: mixedList,
      };
      setUploadLoader(false);

      if (onResource === 'resource') {
        dispatch(resourceActions.uploadResourceDocument(sendList, currentId));
      }
    } else {
      setError(
        !inputs.name ? 'name' :
          !uploadedFiles ? 'currentFile' : '',
      );
    }
  };

  const handleEdit = () => {
    if (inputs.name && defaultValue) {
      const sendFile = {
        name: inputs?.name,
        description: inputs?.description,
        id: defaultValue?._id,
        file: {
          ...defaultValue?.file,
        },
      };
      if (onResource === 'resource') {
        dispatch(resourceActions.editResourceDocument(currentId, defaultValue?._id, sendFile));
      }

    } else {
      setError(
        !inputs.name ? 'name' : '',
      );
    }
  };

  const removeStates = () => {
    setInputs({});
    setError('');
  };

  useEffect(() => {
    if (success) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
      removeStates();
      close();
    }
  }, [success]);


  useEffect(() => {
    if (successEdit) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(editActionType));
      removeStates();
    }
  }, [successEdit]);


  function handleChange(e) {
    setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
  }


  const handleRemove = (index) => {
    setUploadedFiles((prev) => prev.filter((item, i) => i !== index));
  };

  return (
    <div className='upload-document-wrapper'>
      <p className={globalText.modalTitle}>
        {defaultValue ? 'Edit Document' : 'Upload Document'}
      </p>

      <p className={globalText.modalText}>
        {defaultValue ? 'Edit the document\'s title or description.' : 'Select a document to upload and add optional details.'}
      </p>

      <div className='modal-body-wrapper-full'>
        <ValidationInput
          onChange={handleChange}
          value={inputs.name}
          variant={'outlined'}
          name={'name'}
          type={'text'}
          placeholder={'Name*'}
          label={'Document Name*'}
          typeError={error === 'name' ? ErrorText.field : ''}
          Length={50}
        />

        <ValidationInput
          style={'upload-document-textarea'}
          className={inputs.comments && globalStyles.inputTextFieldBlue}
          onChange={handleChange}
          value={inputs.description}
          typeError={error === 'description' && ErrorText.field}
          label={'Document Description*'}
          type={'text'}
          variant={'outlined'}
          name={'description'}
          multiline
          Length={100}
        />
        {defaultValue ?
          <div
            className={`uploaded-file-item-block `}>
            <div className='uploaded-file-item-image-type'>
              <img src={renderFileTypeSvg(defaultValue?.file)} alt='new file type' />
            </div>

            <div className='uploaded-file-item-content'>
              <div className='uploaded-file-item-content-header'>
                <TextToolTip
                  text={defaultValue?.name}
                  content={defaultValue?.name}
                  classNameText='uploaded-file-item-file-name'
                />
              </div>

              <div className='uploaded-file-item-content-body'>
                <div className='uploaded-file-item-content-body-liner' />

                <div className='uploaded-file-item-is-done-failed'>
                  <div className='uploaded-file-item-is-done'>
                    <img src={Images.CheckboxBase} alt='done' />
                  </div>

                  <p className='uploaded-file-item-is-done-text'>
                    Done
                  </p>
                </div>
              </div>
            </div>
          </div>
          :
          <div
            style={{
              pointerEvents: !inputs.name ? 'none' : 'auto',
              opacity: !inputs.name ? '.7' : '1',
            }}
          >
            <NewDragAndDrop
              disabledUpload={!inputs.name}
              onlyFile
              downloadFileImmediately
              handleUploadFile={(file) => {
                setError('');
                handleUpload(file);
              }}
            />
          </div>
        }


        {!!uploadedFiles?.length &&
          <div className='flex' style={{ flexDirection: 'column', gap: 10 }}>
            {uploadedFiles.map((file, j) => (
                <div
                  key={j}
                  className={`uploaded-file-item-block `}>
                  <div className='uploaded-file-item-image-type'>
                    <img src={renderFileTypeSvg(file)} alt='new file type' />
                  </div>

                  <div className='uploaded-file-item-content'>
                    <div className='uploaded-file-item-content-header'>
                      <TextToolTip
                        text={file?.name}
                        content={file?.name}
                        classNameText='uploaded-file-item-file-name'
                      />

                      <button
                        className='uploaded-file-item-file-trash'
                        onClick={() => handleRemove(j)}
                      >
                        <img src={Images.trashIcon} alt='trash' />
                      </button>
                    </div>

                    <div className='uploaded-file-item-content-body'>
                      <div
                        className='uploaded-file-item-content-body-liner'
                      />

                      <div className='uploaded-file-item-is-done-failed'>
                        <div className='uploaded-file-item-is-done'>
                          <img src={Images.CheckboxBase} alt='done' />
                        </div>

                        <p className='uploaded-file-item-is-done-text'>
                          Done
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ),
            )}
          </div>
        }
      </div>

      <CreateChancel
        loader={uploadLoader || !!addLoader?.length || !!editLoader?.length}
        create={defaultValue ? 'Save' : 'Add'}
        chancel={'Cancel'}
        onCreate={defaultValue ? handleEdit : handleSubmit}
        onClose={close}
        buttonWidth='223px'
        createButnMargin={'16px'}
        disabled={defaultValue ? false :
          !uploadedFiles?.length}
      />
    </div>
  );
};